import { useState } from 'react';
import { IconChevronDown, IconMetronome, IconVinyl } from '@tabler/icons-react';
import classNames from 'classnames';

import s from './mobile-plugins.module.scss';
import { AudioControlsContext, AudioControlsProvider } from './audio-controls-provider';
import { WebAudioProvider } from './web-audio-provider';
import { PluginsTabs } from './plugins';

/**
 * Мобильный вариант инструментов синхронного аудио (плеер + метроном)
 * для шторки материалов. По умолчанию свёрнут в одну компактную строку,
 * занимающую минимум места; по тапу разворачивается.
 */
export const MobilePlugins = () => {
	const [collapsed, setCollapsed] = useState(true);

	return (
		<WebAudioProvider>
			<AudioControlsProvider>
				<AudioControlsContext.Consumer>
					{({ amIPlayingJukeBox, someoneElsePlayingJukeBox }) => (
						<div className={classNames(s.mobilePlugins, collapsed && s.collapsed)}>
							<button
								type="button"
								className={s.header}
								onClick={() => setCollapsed((prev) => !prev)}
							>
								<span className={s.headerIcons}>
									<IconVinyl />
									<IconMetronome />
								</span>
								<span className={s.headerTitle}>
									{someoneElsePlayingJukeBox
										? 'Аудио включил собеседник'
										: 'Аудио и метроном'}
								</span>
								{amIPlayingJukeBox && <span className={s.playingDot} />}
								<IconChevronDown className={classNames(s.chevron, collapsed && s.collapsed)} />
							</button>
							{!collapsed && (
								<div className={s.body}>
									<PluginsTabs className={s.mobileTabs} />
								</div>
							)}
						</div>
					)}
				</AudioControlsContext.Consumer>
			</AudioControlsProvider>
		</WebAudioProvider>
	);
};
